// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1Zt4F","footer":"ModalFilter_footer__3-1bg"};